import React from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ButtonBase from "@mui/material/ButtonBase";
// import Icon from "../../utils/Icon";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

export const Slidingcard = () => {

  
  const Img = styled("img")({
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  });

  // function SampleNextArrow(props) {
  //   const { className, style, onClick } = props;
  //   return (
  //     <div
  //       className={className}
  //       style={{ ...style, display: "block", background: "red" }}
  //       onClick={onClick}
  //     />
  //   );
  // }

  // function SamplePrevArrow(props) {
  //   const { className, style, onClick } = props;
  //   return (
  //     <div
  //       className={className}
  //       style={{ ...style, display: "block", background: "green", }}
  //       onClick={onClick}
  //     />
  //   );
  // }

  const data = [
    {
      id: "1",
      title: "Get 25% off every subscription at Cheff Juna Resto",
      image: "./images/Frame 807.svg",
    },
    {
      id: "1",
      title: "Get 25% off every subscription at Cheff Juna Resto",
      image: "./images/Frame 807.svg",
    },
    {
      id: "1",
      title: "Get 25% off every subscription at Cheff Juna Resto",
      image: "./images/Frame 807.svg",
    },
    {
      id: "1",
      title: "Get 25% off every subscription at Cheff Juna Resto",
      image: "./images/Frame 807.svg",
    },
    {
      id: "1",
      title: "Get 25% off every subscription at Cheff Juna Resto",
      image: "./images/Frame 807.svg",
    },
    {
      id: "1",
      title: "Get 25% off every subscription at Cheff Juna Resto",
      image: "./images/Frame 807.svg",
    },
    {
      id: "1",
      title: "Get 25% off every subscription at Cheff Juna Resto",
      image: "./images/Frame 807.svg",
    },
  ];

  const slickArrowIconStyle = {
    fill: "#2b817b",
    background: "#f6f6f6",
    border: "1px solid #E1E1E6",
    borderRadius: "50%",
    // padding: "4px",
  };

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
    // nextArrow: (
    //   <SlickArrow>
    //     <KeyboardArrowRightIcon name="arrow-next" size="14" style={slickArrowIconStyle}  />
    //   </SlickArrow>
    // ),
    // prevArrow: (
    //   <SlickArrow>
    //     <KeyboardArrowLeftIcon name="arrow-prev" size="14" style={slickArrowIconStyle}
    //     //  sx={{marginRight: "30px"}}
    //      />
    //   </SlickArrow>
    // ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   speed: 2000,
  //   autoplaySpeed: 2000,
  //   cssEase: "linear"
  // };

  return (
    <>
      <Box sx={{}}>
        {/* <Grid container spacing={2}> */}
        {/* <Slider {...settings} style={{ margin: "0 30px"}}> */}
        <Slider {...settings} className="slickSliderStyles">
          {data.map((v, i) => {
            return (
              <>
                {/* <Grid item lg={4} md={4} sm={6} xs={12}> */}
                <Box
                  sx={{
                    
                    // maxWidth: "416px",
                    width: {xl: "390px", lg: "390px", md: "100%", sm: "100%", xs: "100%",},
                    height: {xl: "128px", lg: "128px", md: "140px", sm: "150px", xs: "150px"},
                    flexGrow: 1,
                    boxShadow: "none",
                    border: "1px solid #E1E1E6",
                    
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Box
                      direction="column"
                      sx={{
                        pl: "16px",
                        pt: "16px",
                        pb: "16px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box>
                        <Typography
                          gutterBottom
                          variant="subtitle1"
                          component="div"
                          sx={{fontSize: {xl: "16px" ,lg: "16px", md: "16px", sm: "14px", xs: "12px"}, fontWeight: "500"}}
                        >
                          {v.title}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            cursor: "pointer",
                            // fontSize: "16px",
                            fontWeight: "400",
                            color: "#2B817B",
                            textDecoration: "underline",
                            fontSize: {xl: "16px", lg: "16px", md: "16px", sm: "14px", xs: "8px"}, fontWeight: "400"
                          }}
                          variant="body2"
                        >
                          Order now
                        </Typography>
                      </Box>
                    </Box>

                    <Box>
                      <ButtonBase sx={{ width: {xl: "155px", lg: "155px", md: "165px", sm: "155px", xs: "180px"},
                      //  height: "128px"
                      height: {xl: "128px", lg: "128px", md: "140px", sm: "128px", xs: "148px"}
                        }}>
                        <Img alt="complex" src={v.image} width="100%" height="auto" />
                      </ButtonBase>
                    </Box>
                  </Box>
                </Box>
                {/* </Grid> */}
              </>
            );
          })}
        </Slider>
        {/* </Grid> */}
      </Box>
    </>
  );
};
